// extracted by mini-css-extract-plugin
export default {"patient-list":"AdminPatientList_patient-list__ut+TG","PatientlistContainer":"AdminPatientList_PatientlistContainer__QXeKW","loader":"AdminPatientList_loader__lGtPH"};